import * as AC from "adaptivecards";
import { copyRenderedCardToClipboard } from "./copyCardToClipboard.js";

export const ACTION_POPOVER_TYPE = "Action.Popover";

// Same clipboard glyph Centro already ships for Adaptive Card icons.
export const COPY_ICON_DATA_URI =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA0LjA5djYuNDFBMi41IDIuNSAwIDAgMCA2LjM0IDEzaDQuNTdjLS4yLjU4LS43NiAxLTEuNDEgMUg2YTMgMyAwIDAgMS0zLTNWNS41YzAtLjY1LjQyLTEuMiAxLTEuNDFaTTExLjUgMmMuODMgMCAxLjUuNjcgMS41IDEuNXY3YzAgLjgzLS42NyAxLjUtMS41IDEuNWgtNUExLjUgMS41IDAgMCAxIDUgMTAuNXYtN0M1IDIuNjcgNS42NyAyIDYuNSAyaDVabTAgMWgtNWEuNS41IDAgMCAwLS41LjV2N2MwIC4yOC4yMi41LjUuNWg1YS41LjUgMCAwIDAgLjUtLjV2LTdhLjUuNSAwIDAgMC0uNS0uNVoiLz48L3N2Zz4=";

export function isCopyCatalogIcon(iconUrl) {
    if (!iconUrl) return false;
    const value = String(iconUrl).trim();
    return /^icon:copy$/i.test(value) || /(?:^|[/:])copy$/i.test(value);
}

export function resolveCatalogIconUrl(iconUrl) {
    if (isCopyCatalogIcon(iconUrl)) {
        return COPY_ICON_DATA_URI;
    }
    return iconUrl;
}

export class ActionPopover extends AC.Action {
    constructor() {
        super();
        this.catalogIconUrl = undefined;
        this.popoverCard = undefined;
    }

    getJsonTypeName() {
        return ACTION_POPOVER_TYPE;
    }

    get isCopyAction() {
        return isCopyCatalogIcon(this.catalogIconUrl || this.iconUrl);
    }

    internalParse(source, context) {
        super.internalParse(source, context);
        const payload = source || {};
        this.catalogIconUrl = payload.iconUrl;
        this.popoverCard = payload.card || payload.content;
        if (isCopyCatalogIcon(this.iconUrl)) {
            this.iconUrl = COPY_ICON_DATA_URI;
        }
    }

    render() {
        super.render();
        const button = this.renderedElement;
        if (!button) return;
        button.setAttribute("data-ac-action", ACTION_POPOVER_TYPE);
        if (this.catalogIconUrl) {
            button.setAttribute("data-ac-icon-url", this.catalogIconUrl);
        }
        if (this.isCopyAction) {
            button.setAttribute("data-ac-copy-card", "true");
        }
    }

    execute() {
        // Copy popovers are wired after render so they do not submit the card.
    }
}

export function findCopyPopoverButtons(root) {
    if (!root?.querySelectorAll) return [];
    const marked = [...root.querySelectorAll('[data-ac-copy-card="true"]')];
    if (marked.length) return marked;

    return [...root.querySelectorAll("button, [data-ac-action]")].filter((node) => {
        const icon = node.getAttribute?.("data-ac-icon-url") || "";
        const img = node.querySelector?.("img");
        const src = img?.getAttribute("src") || "";
        const label = `${node.title || ""} ${node.getAttribute?.("aria-label") || ""}`;
        return isCopyCatalogIcon(icon)
            || isCopyCatalogIcon(src)
            || /copy to clipboard/i.test(label);
    });
}

export function wireCopyPopoverActions(renderedRoot, options = {}) {
    const copyFn = options.copyFn || copyRenderedCardToClipboard;
    const buttons = findCopyPopoverButtons(renderedRoot);
    buttons.forEach((button) => {
        if (button.dataset.acCopyWired === "true") return;
        button.dataset.acCopyWired = "true";
        button.onclick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            copyFn(renderedRoot, { triggerButton: button, ...options });
        };
    });
    return buttons;
}

export function registerActionPopover(registry = AC.GlobalRegistry.actions) {
    registry.register(ACTION_POPOVER_TYPE, ActionPopover);
    return registry;
}
